import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function Flag(_ref) {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.446 120.465l-24.094-120.468h-542.112v1023.989h120.468v-421.644h337.314l24.094 120.468h421.644v-602.347h-337.314z",
    fill: color
  }));
}
export default Flag;